module.exports = require('./helpers/bundle-url').getBundleURL('bGmkp') + "logo-dark.eefe0b7f.svg";